// Auto-sent as the user's first message in a fresh org chat (never shown in
// the composer, never editable), so it reads in the user's voice. Kept
// deliberately simple — the agent's monitor onboarding skill carries the
// actual flow and playbooks. Shared by the Monitors dashboard "Set up with AI"
// button and the Monitors onboarding modal so both hand off identically.
export const ONBOARDING_CHAT_MESSAGE =
  'Help me set up monitors for my organization. Learn what we do, ask me ' +
  'what you need to know, and recommend and create the right monitors with me.'
